import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
export default {
  async index(params) {
    const currentFactory = store.state.app.factory;
    const C_params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      modelName: 'event_type',
      params: C_params,
    });
    return res;
  },
};
